import React from "react";

const Card = (props) => {
    return (
        <div className={`w-100 text-center p-4 border font-weight-bold ${props.className ?? ''}`}>
            {props.children}
        </div>
    )
}

export default Card;